import type { DataAttributeValues } from './types';

const baseDataAttributePrefix = 'sparing-calculator-web';

const formatDataTrackLinkname = (linkName: string): string => toKebabCase(replaceNorwegianChars(linkName));

// data-testid: For test tools
// data-track-id: For tracking purposes with PIWIK | sparing-calculator-web-${trackId}
// data-track-linkname: For tracking purposes with PIWIK: Should be the same name as button/link/etc label in kebab-case
const createDataAttributeValues = (testId: string, trackId: string, linkName: string): DataAttributeValues => ({
    'data-testid': testId,
    'data-track-id': `${baseDataAttributePrefix}-${trackId}`,
    'data-track-linkname': formatDataTrackLinkname(linkName),
});

export const getCalculatorDataAttrs = (testId: string, linkName: string) =>
    createDataAttributeValues(testId, 'calculator', linkName);

const toKebabCase = (str: string): string =>
    str
        .replace(/([a-z])([A-Z])/g, '$1-$2')
        .replace(/[\s_]+/g, '-')
        .replace(/[^a-zA-Z0-9-]+/g, '-') // replace non-alphanumeric (except dash) with dash
        .replace(/-+/g, '-') // collapse multiple dashes
        .replace(/^-|-$/g, '') // trim leading/trailing dash
        .toLowerCase();

const replaceNorwegianChars = (str: string): string =>
    str
        .replace(/æ/gi, (m) => (m === 'Æ' ? 'Ae' : 'ae'))
        .replace(/ø/gi, (m) => (m === 'Ø' ? 'Oe' : 'oe'))
        .replace(/å/gi, (m) => (m === 'Å' ? 'Aa' : 'aa'));
